<template>
  <div class="gb-analysis">
    <div class="gb-filter-panel">
      <div class="gb-filter-item">
        <div class="gb-filter-label">报告名称</div>
        <div class="gb-filter-content">
          <div class="gb-select">
            <input v-model="filter.name"
                   placeholder="检索报告名称" />
          </div>
        </div>
      </div>
      <div class="gb-filter-item">
        <div class="gb-filter-label">报告类型</div>
        <div class="gb-filter-content">
          <div class="gb-select">
            <input disabled :placeholder="filter.type?$store.state.report.panelType[filter.type]:'请输入报告类型'" />
            <div v-if="filter.type" class="gb-select-clear" @click="()=>{filter.type=''}">
              <a-icon type="close" />
            </div>
            <div class="gb-select-list">
              <div class="gb-select-item" @click="()=>{filter.type=typeIndex}"
                   v-for="(typeItem,typeIndex) in $store.state.report.panelType">
                <a-checkbox :checked="filter.type===typeIndex"></a-checkbox>
                {{typeItem}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gb-table-panel">
      <div class="gb-table-content">
        <div class="gb-table-list" style="background: #E5E5E5;position: absolute;top:0px;">
          <div class="gb-table-item" v-for="dataFieldItem in dataField">
            {{dataFieldItem.title}}
          </div>
        </div>
        <div class="gb-table-list" v-for="dataItem in dataList">
          <div class="gb-table-item" v-for="dataFieldItem in dataField">
            <div v-if="dataFieldItem.code==='option'" style="display: flex;justify-content: space-around">
              <div class="gb-button info gb-margin-right" @click="watchReport(dataItem.code)">查看</div>
              <div class="gb-button info" @click="deletePanel(dataItem.code)">删除</div>
            </div>
            <div v-if="dataFieldItem.code==='type'">
              {{$store.state.report.panelType[dataItem['type']]}}
            </div>
            <div v-else>
              {{dataItem[dataFieldItem.code]}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DeletePanel, GetPanelList} from "../../api/v1/analysis";

export default {
  name: "List",
  data(){
    return {
      filter:{
        name:'',
        type:'',
        group:''
      },
      dataField:[
        {code:'name',title:'报告名'},
        // {code:'code',title:'编码'},
        {code:'group_name',title:'部门'},
        {code:'user_name',title:'报告人'},
        {code:'type',title:'类型'},
        {code:'option',title:'操作'},
      ],
      dataList:[]
    }
  },
  watch:{
    filter:{
      handler(newName, oldName) {
        this.getDataList()
      },
      immediate: false,
      deep: true
    },
  },
  mounted() {
    this.getDataList()
  },
  methods:{
    getDataList(){
      GetPanelList(this.filter).then(resp => {
        if (resp.code===200){
          this.dataList = resp.data
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    watchReport(code){
      let query = this.$route.query
      query.code = code
      this.$router.push({path:'/analysis',query:query})
    },
    deletePanel(code){
      DeletePanel({code:code}).then(resp => {
        if (resp.code===200){
          this.$message.success("删除成功")
          this.getDataList()
        }else{
          this.$message.error(resp.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Analysis/List.vue